<template>
  <div style="display: flex;">
    <ImgView :src="educationForm.img" />
    <div>
      <div>
        <el-form ref="form" :model="educationForm" label-width="120px">
          <el-form-item label="实名：">
<!--            <span>{{educationForm.identityAuth.overallAuthState==2?educationForm.identityAuth.identityName:''}}</span>-->
            {{ educationForm.identityAuth.identityState == 2?educationForm.identityAuth.identityName:educationForm.identityAuth.zhimaState == 1?educationForm.identityAuth.zhimaCertName + ' (芝麻)':educationForm.identityAuth.baiduState == 1?educationForm.identityAuth.baiduCertName + ' (百度)':'' }}
          </el-form-item>

          <el-form-item label="学校：">
            <el-input type="text" v-model="educationForm.schoolName" placeholder="用户学校名字"  style="width:28em;"></el-input>
          </el-form-item>
          <el-form-item label="学历：">
            <el-select v-model="education" placeholder="Select" style="width: 10em">
              <el-option v-for="item in educationArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!--            <span>{{educationForm.education == 1?'初中':educationForm.education == 2?'中专/职高/技校':educationForm.education == 3?'高中':educationForm.education == 4?'大专':educationForm.education == 5?'本科':educationForm.education == 6?'硕士':educationForm.education == 7?'博士':educationForm.education == 8?'博士后':''}}</span>-->
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="educationForm.studyType" placeholder="Select" style="width: 10em">
              <el-option v-for="item in studyTypeArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核结果：">
            <el-radio-group v-model="state">
              <el-radio-button :label="2">通过 <i class="el-icon-check" v-show="state==2"></i></el-radio-button>
              <el-radio-button :label="3">不通过 <i class="el-icon-check" v-show="state==3"></i></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="不通过原因：" v-show="state==3">
            <el-input type="textarea" v-model="educationForm.remark" placeholder="不通过原因仅用户可见" style="width:28em;margin-bottom: 8px;"></el-input>
            <el-radio-group v-model="msg" @change="msgChange">
              <el-radio :label="'请上传毕业证书或学历证明等有效材料。'">请上传毕业证书或学历证明等有效材料</el-radio>
              <el-radio :label="'身份证未认证成功。请先完善身份证资料，再上传认证材料。'">身份证未认证成功。请先完善身份证资料，再上传认证材料</el-radio>
              <el-radio :label="'该材料显示的名字，与用户实名不一致，请重新上传材料。'">该材料显示的名字，与用户实名不一致，请重新上传材料</el-radio>
              <el-radio :label="'材料过于模糊，无法审核。请重新上传清晰材料。'">材料过于模糊，无法审核。请重新上传清晰材料</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="材料类型：">
            <el-radio-group v-model="authType" style="line-height:18px;padding-top:3px;">
              <el-radio :label="1">毕业证书</el-radio>
              <el-radio :label="2">学历证明</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer" style="text-align: center">
        <el-button size="medium" @click="cancel">返 回</el-button>
        <el-button type="primary"  @click="submit" v-loading="submitLoading">提 交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateAuthEdu } from '@/api/url'
import { postFormData } from '@/api/api'
import ImgView from "@/views/auth/components/ImgView";
import {common, auth} from "@/assets/shared/select-constant";

export default {
  name: "JobDialog",
  components: { ImgView },
  props: {
    value: Object
  },
  data() {
    return {
      educationForm: this.value.educationForm,
      authType: this.value.educationForm.authType?this.value.educationForm.authType:0,
      submitLoading: false,
      state: 2,
      msg: '',

      educationArray: [
        // {label:"初中",value:1},
        // {label:"中专/职高/技校",value:2},
        {label:"大专以下",value:3},
        {label:"大专",value:4},
        {label:"本科",value:5},
        {label:"硕士",value:6},
        {label:"博士",value:7},
        {label:"博士后",value:8}
      ],

      education: this.value.educationForm.education <= 3?3:this.value.educationForm.education,

      studyTypeArray: [
        {label:"-",value:0},
        {label:"全日制",value:2},
        {label:"非全日制",value:3},
        {label:"继续教育",value:4},
        {label:"其它",value:1},
      ],

    }
  },
  methods: {

    //返回
    cancel() {
      // this.educationForm = this.value.educationForm,
      this.$emit('close');
    },


    msgChange(){
      this.educationForm.remark = this.msg;
    },

    //提交
    submit() {
      if(this.state == 3 && !this.educationForm.remark){
        this.$message({
          showClose: true,
          duration: 1500,
          message: '不通过原因不能为空',
          type: 'warning'
        })
        return;
      }
      this.$confirm(this.state == 2?'确定要给予【'+this.educationForm.nickName+'】通过吗？':this.state == 3?'确定要给予【'+this.educationForm.nickName+'】不通过吗？':'').then(() => {
        this.submitLoading = true;
        let _this = this;
        let param = {};
        param['id'] = this.educationForm.id;
        param['userId'] = this.educationForm.userId;
        param['schoolName'] = this.educationForm.schoolName;
        param['education'] = this.education;
        param['studyType'] = this.educationForm.studyType;
        param['state'] = this.state;
        param['authType'] = this.authType;
        param['remark'] = this.state == 3?this.educationForm.remark:'';
        postFormData(updateAuthEdu,param).then(function(data){
          let {code,msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.$emit('confirm')
            _this.$emit('close');
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          _this.submitLoading = false;
        })
            .catch(function(response){
              _this.submitLoading = false;
            })
      })
          .catch(() => {})
    }
  },
  watch: {

  },
  mounted() {

  },
  created() {
  }

}
</script>

<style>

</style>
